/* tslint:disable */
/* eslint-disable */
/**
 * Swagger wiegaaterkoffiehalen
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.3.5
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Order } from './Order';
import {
    OrderFromJSON,
    OrderFromJSONTyped,
    OrderToJSON,
    OrderToJSONTyped,
} from './Order';
import type { UserProfile } from './UserProfile';
import {
    UserProfileFromJSON,
    UserProfileFromJSONTyped,
    UserProfileToJSON,
    UserProfileToJSONTyped,
} from './UserProfile';

/**
 * 
 * @export
 * @interface Drawing
 */
export interface Drawing {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    group: string;
    /**
     * Number of group members at the start of the drawing (-1 if unknown)
     */
    membersCount?: number;
    /**
     * ISO 8601 date-time
     */
    start: string;
    /**
     * ISO 8601 date-time
     */
    end: string;
    /**
     * 
     */
    startedBy: UserProfile;
    /**
     * 
     */
    seconds: number;
    /**
     * 
     */
    self: boolean;
    /**
     * 
     */
    open: boolean;
    /**
     * 
     */
    orders: Array<Order>;
    /**
     * 
     */
    endsInSeconds: number;
    /**
     * 
     */
    who?: UserProfile;
}

/**
 * Check if a given object implements the Drawing interface.
 */
export function instanceOfDrawing(value: object): value is Drawing {
    if ((!('id' in (value as Record<string, any>)) && !('_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['id'] === undefined && (value as Record<string, any>)['_id'] === undefined)) return false;
    if (!('group' in value) || value['group'] === undefined) return false;
    if (!('start' in value) || value['start'] === undefined) return false;
    if (!('end' in value) || value['end'] === undefined) return false;
    if (!('startedBy' in value) || value['startedBy'] === undefined) return false;
    if (!('seconds' in value) || value['seconds'] === undefined) return false;
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('open' in value) || value['open'] === undefined) return false;
    if (!('orders' in value) || value['orders'] === undefined) return false;
    if ((!('endsInSeconds' in (value as Record<string, any>)) && !('EndsInSeconds' in (value as Record<string, any>))) || ((value as Record<string, any>)['endsInSeconds'] === undefined && (value as Record<string, any>)['EndsInSeconds'] === undefined)) return false;
    return true;
}

export function DrawingFromJSON(json: any): Drawing {
    return DrawingFromJSONTyped(json, false);
}

export function DrawingFromJSONTyped(json: any, ignoreDiscriminator: boolean): Drawing {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['_id'],
        'group': json['group'],
        'membersCount': json['membersCount'] == null ? undefined : json['membersCount'],
        'start': json['start'],
        'end': json['end'],
        'startedBy': UserProfileFromJSON(json['startedBy']),
        'seconds': json['seconds'],
        'self': json['self'],
        'open': json['open'],
        'orders': ((json['orders'] as Array<any>).map(OrderFromJSON)),
        'endsInSeconds': json['EndsInSeconds'],
        'who': json['who'] == null ? undefined : UserProfileFromJSON(json['who']),
    };
}

export function DrawingToJSON(json: any): Drawing {
    return DrawingToJSONTyped(json, false);
}

export function DrawingToJSONTyped(value?: Drawing | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        '_id': value['id'],
        'group': value['group'],
        'membersCount': value['membersCount'],
        'start': value['start'],
        'end': value['end'],
        'startedBy': UserProfileToJSON(value['startedBy']),
        'seconds': value['seconds'],
        'self': value['self'],
        'open': value['open'],
        'orders': ((value['orders'] as Array<any>).map(OrderToJSON)),
        'EndsInSeconds': value['endsInSeconds'],
        'who': UserProfileToJSON(value['who']),
    };
}

